module.exports = __webpack_public_path__ + "h5/img/customer.e4fbb365.png";